<mat-icon
    [class]="className + customClass"
    [class.pointer]="isPointer"
    [style.font-variation-settings]="fontVariationSettings"
    [style.width.px]="size"
    [style.height.px]="size"
    [style.font-size.px]="size"
    [style.color]="customColor ? customColor : null"
    fontSet="material-symbols-outlined">
        {{ name }}
    </mat-icon
>
